module.exports = "./app-dist/templates/browse.component.588be2a8369e5f340eafeee31aff3198.html";